export default __webpack_public_path__ + "static/img-ei-6-aa3a13785a3b5e87fb6d996aae8d8296.png";